import { FETCH_SETTINGS } from "./types";

export const fetchFeatureSettings = (settings: any[]): { type: string; payload: any[] } => {
    return {
        type: FETCH_SETTINGS,
        payload: settings,
    };
};
